import React, { useState, useEffect } from "react";
import divider from "../pattern-divider-mobile.svg";
import dice from "../icon-dice.svg";

function Card() {
  const [advice, getAdvice] = useState({});
  useEffect(() => {
    fetch("https://api.adviceslip.com/advice")
      .then((res) => res.json())
      .then((json) => {
        getAdvice(json.slip);
      });
  }, []);
  const handleClick = () => {
    fetch("https://api.adviceslip.com/advice")
      .then((response) => response.json())
      .then((responseData) => {
        getAdvice(responseData.slip);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  return (
    <div className="flex flex-row justify-center items-center h-screen bg-gray-800">
      <div className="p-4 flex flex-col justify-center items-center bg-gray-700 mx-4 my-8 rounded-md">
        <h2 className="text-green-400 m-3 tracking-widest font-light">
          ADVICE #{advice.id}
        </h2>
        <p className="text-white m-6 text-2xl text-center mb-8">
          “{advice.advice}”
        </p>
        <img src={divider} alt="pause" className="p-4"></img>
        <button
          className="relative bg-green-400 rounded-full bg-center p-4 overflow-visible top-10 hover:bg-green-300"
          onClick={handleClick}
        >
          <img src={dice} alt="dice"></img>
        </button>
      </div>
    </div>
  );
}

export default Card;
